// Strict, practical email address validation (ASCII addresses only), checked in the browser before asking the API to send a code.
// Same rules as nodeApi/helpers/email-validate.js; test-vectors/email-validation.json is checked against both.
const LOCAL_RE = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/; // no leading/trailing/double dots
const LABEL_RE = /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;
const TLD_RE = /^(?:[A-Za-z]{2,63}|xn--[A-Za-z0-9-]{2,59})$/;

// e must already be trimmed
export function isValidEmail(e) {
  if (typeof e !== 'string' || e.length < 6 || e.length > 254) return false;
  const at = e.indexOf('@');
  if (at < 1 || at !== e.lastIndexOf('@')) return false;
  const local = e.slice(0, at);
  const domain = e.slice(at + 1);
  if (local.length > 64 || domain.length > 253) return false;
  if (!LOCAL_RE.test(local)) return false;
  const labels = domain.split('.');
  if (labels.length < 2) return false;
  for (let i = 0; i < labels.length; i += 1) {
    if (!LABEL_RE.test(labels[i])) return false;
  }
  return TLD_RE.test(labels[labels.length - 1]);
}
